var _path, _path2, _path3, _path4, _circle;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgUdeliveredConvert = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 20,
    viewBox: "0 0 29 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.07286 11.7691L6.10352e-05 5.71634V18.9747L7.07286 11.7691Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8881 12.5202L13.9127 14.2109C12.7633 15.1949 11.076 15.1949 9.92587 14.2109L8.00429 12.5665L0.846375 19.8592H23.0923L15.8881 12.5202V12.5202Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0646 8.1916C18.4164 7.29141 18.0303 6.19035 18.016 5.00009H1.04456L10.7219 13.2815C11.4117 13.8712 12.4269 13.8712 13.1167 13.2815L19.0646 8.1916Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8386 10.5155C22.3808 10.5761 20.9719 10.0736 19.8831 9.10126L16.8196 11.7228L23.8386 18.8733V10.5155Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5303,
    cy: 4.53029,
    r: 4.53029,
    fill: "#E7B92A"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUdeliveredConvert, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/udelivered-convert.87ccbe1f.svg";
export { ForwardRef as ReactComponent };